module.exports = __webpack_public_path__ + "img/1scan.6998298a.png";